import { Link } from "react-router-dom";
import { Calendar, CheckCircle2 } from "lucide-react";

const CtaBanner = ({ title = "Start running your business from one platform", body = "Set up your account in minutes and see your first job on the calendar today." }) => (
  <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8" data-testid="cta-banner">
    <div className="max-w-7xl mx-auto relative overflow-hidden bg-[#0F172A] rounded-3xl py-14 md:py-16 px-6 sm:px-12 text-center shadow-2xl">
      <div
        className="absolute inset-0 pointer-events-none"
        aria-hidden="true"
        style={{ background: "radial-gradient(ellipse 700px 320px at 50% 0%, rgba(0,70,190,0.35) 0%, transparent 70%)" }}
      />
      <div className="relative z-10 max-w-2xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white leading-[1.15] mb-4">{title}</h2>
        <p className="text-lg text-slate-300 leading-relaxed mb-8">{body}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3.5 mb-5">
          <Link to="/register" className="mk-btn mk-btn-white mk-btn-lg w-full sm:w-auto" data-testid="cta-banner-trial-btn">
            Start Your 7-Day Free Trial
          </Link>
          <Link
            to="/book-demo"
            className="mk-btn mk-btn-lg w-full sm:w-auto text-white border-white/25 hover:border-white/60"
            style={{ background: "transparent", borderWidth: "1.5px" }}
            data-testid="cta-banner-demo-btn"
          >
            <Calendar className="w-4 h-4" /> Book a Demo
          </Link>
        </div>
        <p className="flex items-center justify-center gap-1.5 text-[13.5px] text-slate-400 font-medium">
          <CheckCircle2 className="w-4 h-4 text-emerald-400" /> No credit card required
        </p>
      </div>
    </div>
  </section>
);

export default CtaBanner;
